import { render, staticRenderFns } from "./SendConfirmation.vue?vue&type=template&id=79191c7d&scoped=true"
import script from "./SendConfirmation.vue?vue&type=script&lang=ts"
export * from "./SendConfirmation.vue?vue&type=script&lang=ts"
import style0 from "./SendConfirmation.vue?vue&type=style&index=0&id=79191c7d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79191c7d",
  null
  
)

export default component.exports